<template>
  <div class="page_all">
    <div class="return_link"></div>   
    <div class="page_header">
      <div class="header_title">
        <div class="title">避難先</div>
        <div class="area_checkboxs_div">
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="en_check" type="checkbox" v-model="checkNameEi">
            <label class="form-check-label area_check_label" for="en_check">英語</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="kan_check" type="checkbox" v-model="checkNameKan" @change="onChangeKan">
            <label class="form-check-label area_check_label" for="kan_check">韓国語</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="chu_han_check" type="checkbox" v-model="checkNameChuHan">
            <label class="form-check-label area_check_label" for="chu_han_check">中国語(繁体字)</label>
          </div>
          <div class="area_checkbox_div">
            <input class="area_checkbox" id="chu_kan_check" type="checkbox" v-model="checkNameChuKan">
            <label class="form-check-label area_check_label" for="chu_kan_check">中国語(簡体字)</label>
          </div>
        </div>
      </div>
      <div>
        <button class="btn_general" v-on:click="open_modal_deleteAllArea()">全件削除</button>
        <modal name="modal_deleteAllArea" :draggable="false" :resizable="false" :height="200">
          <div class="modal_header">
            <p class="modal_title">避難先を全件削除してよろしいですか？</p>
          </div>
          <div class="modal-body">
            <div class="modal_string_div">
              <span class="modal_string string_red">注意：設定されている全ての避難先が完全に削除されます。</span>
            </div>
            <div class="modal_btn_div">
              <button  class="btn btn-outline-primary modal_btn" @click="close_modal_deleteAllArea">キャンセル</button>
              <button class="btn btn-outline-primary" v-on:click="open_modal_deleteAllArea2()">削除</button>
            </div>
          </div>  
        </modal>
        <modal name="modal_deleteAllArea2" :draggable="false" :resizable="false" :height="200">
          <div class="modal_header">
            <p class="modal_title">避難先を全件削除します、本当によろしいですか？</p>
          </div>
          <div class="modal-body">
            <div class="modal_string_div">
              <span class="modal_string string_red">注意：削除を選択で処理が実行されます。</span>
            </div>
            <div class="modal_btn_div">
              <button  class="btn btn-outline-primary modal_btn" @click="close_modal_deleteAllArea2">キャンセル</button>
              <button class="btn btn-outline-primary" v-on:click="deleteAllSehlter()">削除</button>
            </div>
          </div>  
        </modal>
        <button class="btn_general" v-on:click="csv_modal_open()">csv取り込み</button>

        <modal name="modal_csv" :draggable="false" :resizable="false" height="auto">
          <div class="modal_header_csv">
            CSV取り込み
          </div>

          <div>
            <div class="tabs">
              <div :class="[{'active': csvModalTab===1}, 'tab']" v-on:click="changeTab(1)">避難先</div>
              <div :class="[{'active': csvModalTab===2}, 'tab']" v-on:click="changeTab(2)">地域グループとの関連付け</div>
            </div>
          </div>


          <div v-if="csvModalTab == 1">

            <div class="modal_title_div">
              <p class="modal_title_csv">Step1. CSVの作成</p>
              <ul class="modal_detail_ul_csv">
                <li class="modal_detail_li_csv">新規に避難先を登録するための機能です。既に登録済みの避難先の更新は行えません。</li>
                <li class="modal_detail_li_csv">csvファイルは文字コードがUTF-8になっている必要があります。</li>
                <li class="modal_detail_li_csv">災害種別との関連付けを行うため、以下のボタンから現状の災害種別を設定したCSVを取得してご利用ください。</li>
              </ul>
              <div class="dl_btn_div_csv">
                <div>
                  <button class="btn btn-outline-secondary dl_btn" @click="downloadDisasterTemplateCsv">災害種別を設定したCSVを書き出し</button>
                </div>
              </div>
              <div>
                データの入力は以下のサンプルファイルをご確認ください。
              </div>
              <div class="dl_btn_div_csv">
                <div>
                  <button class="btn btn-outline-secondary dl_btn" @click="downloadDisasterSampleCsv">サンプルファイルのダウンロード</button>
                </div>
              </div>
            </div>
            <div class="modal_title_div">
              <p class="modal_title_csv">Step2. CSVの取り込み</p>
              <div>
                <ul class="modal_detail_ul_csv">
                  <li>Step1で作成したCSVを以下のボタンから設定してください。</li>
                  <li>CSVを設定後「取り込み」を選択することで、CSV取り込みを開始します。</li>
                </ul>
              </div>
              <div class="csv_btn">
                <label class="csv_btn_label btn btn-outline-secondary">
                  CSVの設定
                  <input class="csv_input" type="file" @change="onCsvChange" accept=".csv" />
                </label>
              </div>
              <div>
                <p v-if="csvName == ''"><br></p>
                <p>{{ csvName }}</p>
              </div>
            </div>
            <div class="modal_btn_div_csv">
              <button class="btn btn-outline-primary modal_btn" :disabled="shelterDisasterCsvFile == ''" v-on:click="open_modal_import_disaster_csv">csv取り込み</button>
              <button  class="btn btn-outline-primary" @click="close_modal_csv">キャンセル</button>
            </div>

          </div>

          <div v-else>

            <div class="modal_title_div">
              <p class="modal_title_csv">Step1. 避難先と地域グループについて</p>
              <ul class="modal_detail_ul_csv">
                <li class="modal_detail_li_csv">関連付けを行う避難先と地域グループは、事前に登録しておく必要があるため、登録完了後、こちらのCSVでの関連付けを行なってください。</li>
              </ul>
            </div>
            <div class="modal_title_div">
              <p class="modal_title_csv">Step2. CSVの作成</p>
              <ul class="modal_detail_ul_csv">
                <li class="modal_detail_li_csv">登録済みの避難先と地域グループの関連付けを行う機能です。</li>
                <li class="modal_detail_li_csv">全ての避難先と地域グループの関連付けが更新されます。</li>
                <li class="modal_detail_li_csv">csvファイルは文字コードがUTF-8になっている必要があります。</li>
                <li class="modal_detail_li_csv">以下のボタンから現状のデータを設定したCSVを取得してご利用ください。</li>
              </ul>
              <div class="dl_btn_div_csv">
                <div>
                  <button class="btn btn-outline-secondary dl_btn" @click="downloadGroupTemplateCsv">現状のデータをCSV書き出し</button>
                </div>
              </div>
              <div>
                データの入力は以下のサンプルファイルをご確認ください。
              </div>
              <div class="dl_btn_div_csv">
                <div>
                  <button class="btn btn-outline-secondary dl_btn" @click="downloadGroupSampleCsv">サンプルファイルのダウンロード</button>
                </div>
              </div>
            </div>
            <div class="modal_title_div">
              <p class="modal_title_csv">Step3. CSVの取り込み</p>
              <div>
                <ul class="modal_detail_ul_csv">
                  <li>Step2で作成したCSVを以下のボタンから設定してください。</li>
                  <li>CSVを設定後「取り込み」を選択することで、CSV取り込みを開始します。</li>
                </ul>
              </div>
              <div class="csv_btn">
                <label class="csv_btn_label btn btn-outline-secondary">
                  CSVの設定
                  <input class="csv_input" type="file" @change="onCsvChange" accept=".csv" />
                </label>
              </div>
              <div>
                <p v-if="csvName == ''"><br></p>
                <p>{{ csvName }}</p>
              </div>
            </div>
            <div class="modal_btn_div_csv">
              <button class="btn btn-outline-primary modal_btn" :disabled="shelterGroupCsvFile == ''" v-on:click="open_modal_import_group_csv">csv取り込み</button>
              <button  class="btn btn-outline-primary" @click="close_modal_csv">キャンセル</button>
            </div>

          </div>

        </modal>
        <!-- csv import 確認modal -->
        <modal name="modal_import_disaster_csv" :draggable="false" :resizable="false" :height="200">
          <div class="modal_header">
            <p class="modal_title">CSVファイルの取り込みを行います、よろしいですか？</p>
          </div>
          <div class="modal-body-csv">
            <div class="modal_string_div">
              <span class="modal_string">*CSVファイルの取り込みを行うと、現在設定されている避難先に追加で取り込まれます。</span>
            </div>
            <div class="modal_btn_div">
              <button  class="btn btn-outline-primary modal_btn" @click="close_modal_import_disaster_csv">キャンセル</button>
              <button class="btn btn-outline-primary" v-on:click="importShelterDisasterCsv()">取り込み</button>
            </div>
          </div>  
        </modal>
        <modal name="modal_import_group_csv" :draggable="false" :resizable="false" :height="200" :width="650">
          <div class="modal_header">
            <p class="modal_title">CSVファイルの取り込みを行います、よろしいですか？</p>
          </div>
          <div class="modal-body-csv">
            <div class="modal_string_div">
              <span class="modal_string">*CSVファイルの取り込みを行うと、現在設定されている避難先と地域グループの関連付けが更新されます。</span>
            </div>
            <div class="modal_btn_div">
              <button  class="btn btn-outline-primary modal_btn" @click="close_modal_import_group_csv">キャンセル</button>
              <button class="btn btn-outline-primary" v-on:click="importShelterGroupCsv()">取り込み</button>
            </div>
          </div>  
        </modal>
        <button class="btn_plus" v-on:click="shelterAdd()">＋</button>
      </div>
    </div>
    <div v-if="message != ''" class="message">
      <div class="error">{{ message }}</div>
    </div>
    <div class="pager_div">
      <span class="pager_no_span" v-if="totalShelterListCnt == 0">0件</span>
      <span class="pager_no_span" v-else>{{ pagerCnt * pageNo +1 }}-{{ pagerCnt * pageNo + (shelterList ? shelterList.length : 0) }}件/{{ totalShelterListCnt }}件</span>
      <span class="pager_span" v-if="pageNo > 0" @click="pageDown()">＜前へ</span>
      <span class="pager_space" v-else></span>
      <span class="pager_span" v-if="pageNo < (shelterList ? shelterListCnt - 1 : 0)" @click="pageUp()">次へ＞</span>
      <span class="pager_space" v-else></span>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_shelter_name">名称<br>（日本語）</th>
            <th v-if="checkNameEi" class="th_shelter_name">名称<br>（英語）</th>
            <th v-if="checkNameKan" class="th_shelter_name">名称<br>（韓国語）</th>
            <th v-if="checkNameChuHan" class="th_shelter_name">名称<br>（中国語:繁体字）</th>
            <th v-if="checkNameChuKan" class="th_shelter_name">名称<br>（中国語:簡体字）</th>
            <th class="th_lati">緯度</th>
            <th class="th_lati">経度</th>

            <th class="th_disaster" v-for="disaster in disasters" v-bind:key="disaster.disaster_id">
              {{ disaster.disaster_name }}
            </th>
            
            <th class="th_group">地域グループ</th>
            <th class="th_delete">削除</th>
          </tr>
        </thead>
        <tbody class="tbl_tbody">
          <tr v-for="shelter in shelterList ? shelterList : shelterList" v-bind:key="shelter.shelter_id">
            <td class="td_push_name">
              <router-link v-on:click.native="shelterUpdate(shelter.shelter_id)" to="">{{ shelter.shelter_name }}</router-link>
            </td>
            <td v-if="checkNameEi" class="td_title">
              {{ shelter.shelter_name_ei }}
            </td>
            <td v-if="checkNameKan" class="td_title">
              {{ shelter.shelter_name_kan }}
            </td>
            <td v-if="checkNameChuHan" class="td_title">
              {{ shelter.shelter_name_chu_han }}
            </td>
            <td v-if="checkNameChuKan" class="td_title">
              {{ shelter.shelter_name_chu_kan }}
            </td>
            <td class="td_lati">
              {{ shelter.latitude }}
            </td>
            <td class="td_lati">
              {{ shelter.longitude }}
            </td>
            <td class="td_disaster" v-for="disaster in disasters" v-bind:key="disaster.disaster_id">
              <template v-if="shelter.shelter_disaster_ids.includes(disaster.disaster_id)">
                ◯
              </template>
            </td>
            <td class="td_group">
              {{ shelter.shelter_group_names.join(', ') }}
            </td>
            <td class="td_delete">
              <button class="btn_delete" @click="deleteShelter(shelter)">☓</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: {
    ConfirmDialog
  },
  data() {
    return {
      message: "",
      modalHeight: "560px",

      shelterList: null,
      shelterListCnt: 0,
      pageNo: 0,
      pagerCnt: 10,
      totalShelterListCnt: 0,

      csvName: "",
      shelterDisasterCsvFile: "",
      shelterGroupCsvFile: "",

      areas: null,

      disasters:null,
      csvModalTab: 1,

      innerCheckNameEi: sessionStorage.getItem('checkNameEi') != null ? sessionStorage.getItem('checkNameEi') === "true" : "",
      checkNameKan: sessionStorage.getItem('checkNameKan') != null ? sessionStorage.getItem('checkNameKan') === "true" : "",
      innerCheckNameChuHan: sessionStorage.getItem('checkNameChuHan') != null ? sessionStorage.getItem('checkNameChuHan') === "true" : "",
      innerCheckNameChuKan: sessionStorage.getItem('checkNameChuKan') != null ? sessionStorage.getItem('checkNameChuKan') === "true" : "",
    }
  },
  async mounted() {
    this.getDisasterTypeList()
    this.getShelterList()

    // keep scrop position
    // this.$nextTick(() => {
    //   setTimeout(() => {
    //     const positionY = sessionStorage.getItem('pushPositionY')
    //     scrollTo(0, positionY)
    //   }, 500)
    // })
  },
  methods: {
    async getDisasterTypeList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'disaster/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
        }
      })
      this.disasters = response.data
    },
    async getAreaList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'area/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey
          , action_name: "municipality_area_list"
        }
      })
      this.areas = response.data
      console.log("aaaaaaa")
      console.log(response)
      console.log("bbbbbbb")
      // console.log(this.areas.filter(a => a.area_id == 36757)[0]['area_name'])
    },
    pageDown: function() {
      this.pageNo -= 1

      this.getShelterList()
    },
    pageUp: function() {
      this.pageNo += 1

      this.getShelterList()
    },
    async getShelterList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'shelter/list', {
        params: {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          page_no: this.pageNo
        }
      })

      console.log(response.data)
      
      this.shelterList = response.data.shelter_list
      this.totalShelterListCnt = response.data.total_shelter_cnt
      this.shelterListCnt = response.data.shelter_list_cnt
    },
    shelterAdd: function() {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', false)
      this.$router.push({ name: 'shelterDetail' })
    },
    shelterUpdate: function(shelter_id) {
      // 変更フラグ
      this.$store.commit('setStateChangeFlg', true)
      // shelterIdをStoreにセット
      this.$store.commit('setStateShelterId', shelter_id)
      this.$router.push({ name: 'shelterDetail' })
    },
    async deleteShelter(shelter) {
      const result = await this.$refs.deleteDialog.asyncShow(`${shelter.shelter_name}を削除してよろしいですか？`);
      console.log(result)
      if (!result) {
        return;
      }

      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'shelter/del', {
          shelter_id: shelter.shelter_id,
          shelter_name: shelter.shelter_name,
          latitude: shelter.latitude,
          longitude: shelter.longitude
        })
      } catch(err) {
        this.message = err.response.data.errorMessage
      }

      this.getShelterList()
    },
    async deleteAllSehlter() {
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'shelter/list-action', {
          municipality_key: this.$store.getters.getStateMunicipalityKey,
          action_name: "deleteAllShelter"
        })
      } catch(err) {
        this.message = err.response.data.errorMessage
      }

      this.getShelterList()
      this.close_modal_deleteAllArea2()
    },
    onChangeKan: function(event) {
      this.checkNameKan = event.target.checked
      sessionStorage.setItem('checkNameKan', this.checkNameKan)
    },
    downloadDisasterSampleCsv: function() {
      this.downloadFile("downloadCsv", "disastersample.csv", "text/csv")

      this.close_modal_csv()
    },
    downloadGroupSampleCsv: function() {
      this.downloadFile("downloadCsv", "groupsample.csv", "text/csv")

      this.close_modal_csv()
    },
    downloadDisasterTemplateCsv: function() {
      this.downloadFile("downloadCsv", "disastertemplate.csv", "text/csv")

      this.close_modal_csv()
    },
    downloadGroupTemplateCsv: function() {
      this.downloadFile("downloadCsv", "grouptemplate.csv", "text/csv")

      this.close_modal_csv()
    },
    async downloadFile(actionName, fileName, fileHeader) {
      const {response, error} = await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'shelter/list-action', {
        action_name: actionName,
        file_name: fileName
      }, {
        headers: {
          'Accept': fileHeader,
        },
        responseType: "blob",
      }).then(response => ({response}))
      .catch(error => ({error}));
      // this.downloading = false;
      if (error) {
        this.message = error.response.data.errorMessage;
        return null;
      }

      const blob = new Blob([response.data], {type: response.headers["content-type"]});
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href)
      }
    },
    onCsvChange: function(e) {
      if (this.csvModalTab == 1) {
        const files = e.target.files || e.dataTransfer.files;
        this.shelterDisasterCsvFile = files[0]
        this.csvName = files[0].name;      
      } else {
        const files = e.target.files || e.dataTransfer.files;
        this.shelterGroupCsvFile = files[0]
        this.csvName = files[0].name;      
      }
    },
    csv_modal_open: function() {
      this.csvModalTab = 1
      this.shelterCsvFile = ""
      this.csvName = ""
      this.$modal.show("modal_csv")
    },
    async importShelterDisasterCsv() {
      await this.importCsv(this.shelterDisasterCsvFile, "importCsv", "importShelterDisasterCsv")

      this.getShelterList()
      this.close_modal_import_disaster_csv()
    },
    async importShelterGroupCsv() {
      await this.importCsv(this.shelterGroupCsvFile, "importCsv", "importShelterGroupCsv")

      this.getShelterList()
      this.close_modal_import_group_csv()
    },
    async importCsv(file, actionName, fileName) {
      if (file != "" || file != null) {
        var toBase64 = file => new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        })
      }
      const data = {
        "file": (await toBase64(file)).replace(/data:.*\/.*;base64,/, ''),
        "file_type": file.type,
        "action_name" : actionName,
        "municipality_key" : this.$store.getters.getStateMunicipalityKey,
        "file_name": fileName
      }
      this.isLoading = true
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'shelter/list-action'
                                                        , data
                                                        , {headers: {'Content-Type': "test/json"},})
        this.message = ""
      } catch (err) {
        console.log(err)
         this.message = err.response.data.errorMessage
      }
      console.log("test")
      this.isLoading = false
    },
    close_modal_csv: function() {
      this.$modal.hide("modal_csv")
    },
    open_modal_import_disaster_csv: function() {
      this.$modal.hide("modal_csv")
      this.$modal.show("modal_import_disaster_csv")
    },
    open_modal_import_group_csv: function() {
      this.$modal.hide("modal_csv")
      this.$modal.show("modal_import_group_csv")
    },
    close_modal_import_disaster_csv: function() {
      this.$modal.hide("modal_import_disaster_csv")
    },
    close_modal_import_group_csv: function() {
      this.$modal.hide("modal_import_group_csv")
    },
    open_modal_deleteAllArea: function() {
      this.$modal.show("modal_deleteAllArea")
    },
    close_modal_deleteAllArea: function() {
      this.$modal.hide("modal_deleteAllArea")
    },
    open_modal_deleteAllArea2: function() {
      this.$modal.hide("modal_deleteAllArea")
      this.$modal.show("modal_deleteAllArea2")
    },
    close_modal_deleteAllArea2: function() {
      this.$modal.hide("modal_deleteAllArea2")
    },
    onCancel:function() {
      console.log('User cancelled the loader.')
    },
    changeTab:function(no) {
      this.csvModalTab = no
      if (no == 1) {
        this.modalHeight = "560px"
      } else {
        this.modalHeight = "700px"
      }
    }
  },
  computed: {
    checkNameEi: {
      get() {
        return this.innerCheckNameEi
      },
      set(value) {
        this.innerCheckNameEi = value
        sessionStorage.setItem('checkNameEi', value)
      }
    },
    checkNameChuHan: {
      get() {
        return this.innerCheckNameChuHan
      },
      set(value) {
        this.innerCheckNameChuHan = value
        sessionStorage.setItem('checkNameChuHan', value)
      }
    },
    checkNameChuKan: {
      get() {
        return this.innerCheckNameChuKan
      },
      set(value) {
        this.innerCheckNameChuKan = value
        sessionStorage.setItem('checkNameChuKan', value)
      }
    },
    areaNameFromAreaId: function() {
      return function(value) {
        if(this.areas) {
          var area = this.areas.filter(a => a.area_id == value)
          console.log(area)
          if (area.length > 0) {
            var areaName = area[0]['area_name']
          }

            return areaName 
        } else {
          return null
        }
      }
    },
  }
}
</script>

<style scoped>
.page_all {
  width: 1100px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
}
.page_main{
  overflow-x: scroll;
}
.tbl_main {
  min-width: 1100px;
  /* overflow-x: scroll; */
  /* white-space: nowrap; */
  table-layout: fixed;
  width: 900px;
  border: 1px #666666 solid;
  border-collapse: collapse;
}
.tbl_tbody {
  /* width: 100%;
  display: table; */
}
.tbl_main_wide {
  width: 900px;
  border: 1px #666666 solid;
  border-collapse: collapse;
}
table th.th_shelter_name {
  width: 150px;
  /* min-width: 190px;
  height: 10px; */
  text-align: center;
  padding-left: 10px;
}
table th.th_lati {
  width: 200px;
  text-align: left;
  padding-left: 10px;
}
table th.th_disaster {
  width: 75px;
  text-align: left;
  padding-left: 10px;
}
table th.th_group {
  width: 150px;
  text-align: left;
  padding-left: 10px;
}
.th_delete {
  width: 50px;
}
table td {
  word-break: break-all;
}
table td.td_push_name, td.td_title {
  text-align: left;
  padding-left: 10px;
}
.pager_div {
  display: flex;
  justify-content: flex-end;
}
.pager_no_span {
  font-size: smaller;
}
.pager_span {
  margin: 0 0 0 10px;
  font-size: smaller;
  cursor: pointer;
}
.pager_space {
  margin-left: 40px;
}
.area_checkboxs_div {
  margin: 0 0 0 20px;
  display: flex;
}
.area_checkbox_div {
  margin: 0 10px 0 0 ;
}
.area_checkbox {
  margin: 0 3px 0 0;
}
.area_check_label {
  font-size: smaller;
}
.btn_general {
  margin: 0 20px 0 0;
  height: 30px;
  width: 100px;
}
.modal_header {
  margin: 10px 0 20px 20px;
}
.modal_body {
}
.modal_title_div {
  text-align: left;
  font-size: small;
  padding: 10px 0 0 20px;
  border-bottom: 1px solid #ddd;
}
.csv_ul {
  text-align: left;
  font-size: smaller;
  margin: 0 0 0 -20px;
}
.dl_btn_div_csv {
  text-align: left;
  margin: 0 0 20px 0
}
.dl_btn {
  margin-top: 5px;
  width: 250px;
  font-size: small;
}
.modal_string_div {
  height: 50%;
}
.modal_string {
  font-size: small;
}
.string_red {
  color: red;
}
.modal_btn_div_csv {
  height: 50%;
  text-align: right;
  margin-top: 12px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.modal_btn_div {
  height: 50%;
  margin-top: 20px;
}
.modal_btn {
  margin: 0 10px 0 0;
}
.csv_btn {
  margin: 10px 0 0 0;
}
.csv_btn_label {
  padding: 0 1rem;
  border: solid 1px #888;
  border-radius: 0.25rem;
  cursor: pointer;
}
.csv_input {
  display: none;
}
.tabs {
  display: flex;
}
.tab {
  /* font-size:medium; */
  padding: 5px 5px;
  border: 1px solid #ccc;
  cursor: pointer;
  transition: .3s;
  width: 50%
}
.active {
  background: #f5f3df;
}
.modal_header_csv {
  font-size:1rem;
  text-align: left;
  padding: 10px 0 10px 10px;
  background-color: #bebcbc;
}
.modal_detail_ul_csv {
  text-align: left;
  font-size: smaller;
  margin: 0 0 0 -20px;  
}
.modal_title_csv {
  font-size: 1rem;
}
.modal_body_csv {
  border-bottom: 1px solid #ddd;
}
</style>